<div id="category" [rdoFillRemainingHeight]>
  <rdo-overlay [enabled]="cardChanging"></rdo-overlay>
  <div class="d-flex flex-row position-relative align-items-stretch scroll-container equipment-container "
    [rdoCollapsedCards]="'product-type-categories'"
    >
    <rdo-collapsible [key]="'product-type-categories'">
      <rdo-nav-card-list
        [list]="cards"
        [titleProperty]="'RouseCategory'"
        [title]="'main.tabs.equipment.all_title'"
        [mode]="mode"
        [currentPage]="categoriesPage"
        [pageSize]="categoriesPageSize"
        (onSelect)="selectCategory($event)"
        (onScroll)="scrollHandler()"
        [selectedItem]="selectedCategory"
        />
    </rdo-collapsible>
    <div class="container-fluid rdo-col-card-offset collapsible-offset">
      <div class="row">
        <div class="col-12">
          <rdo-collapsible-button [key]="'product-type-categories'" />
          @if (selectedCategory) {
            <h3 class="equipment-title"
              id="selected-category-header">
              <rdo-category-icon [category]="selectedCategory.CategoryIcon || selectedCategory.RouseCategory">
              </rdo-category-icon>&nbsp;
              {{selectedCategory.RouseCategory || ('main.tabs.equipment.all_title' | translate)}}
            </h3>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <rdo-overlay [enabled]="loading" />
          <div id="product-type-grid" class="grid-container">
            <ng-container *featureFlag="'flagSavedViews'">
              <rdo-saved-views
                [gridName]="GRID_NAME"
                [pageName]="translateService.instant('main.core.common.counts.product_types.plural')"
                />
            </ng-container>
            @if (productTypes) {
              <rdo-grid-table-configured-expandable
                #productTypeGrid
                [name]="GRID_NAME"
                [dataKey]="dataKey"
                [gridConfig]="gridConfig"
                [columnSelectorConfig]="columnSelectorConfig"
                (gridConfigChange)="onGridConfigChange($event)"
                [pagedData]="productTypes"
                [frozenRows]="frozenRows"
                [rowExpansion]="gridConfig.rowExpansion"
                [sorting]="sorting"
                [(paging)]="paging"
                (pageOnChange)="changePage($event)"
                (lazyLoadOnChange)="changeLazyLoad($event)"
                [totalCount]="totalCount"
                [frozenWidth]="frozenWidth"
                (downloadExcelClick)="exportExcel($event)"
                [useConfiguredColumnSelector]="true"
                [disableExpandability]="!isExpandableView"
                [storage]="'local'"
                [alwaysShowPager]="false"
                />
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
